
/* Add CustomFields Sep 23, 2023 */
/* Add email, phoneno,website, others to Custom Fields Nov 18, 2023 */
/* Add sortable:true Nov 25, 2023 */
/* Add valFmtFn to phone numbers Aug 24, 2024 */
/* Add multiSelect to customData fields  Dec 21, 2024 */
/* Add profilePicture for read Only columns Jan 25, 2025 */
<template lang="pug">
	div(class="team-nav")
		kt-table(
		ref="kt-table"
		p_appEntKey="team"
		:p_cols="c_ktColumns" 
		:p_opts="c_ktOptions"
		)

</template>

<script>
import KTTable from "@/components/Ctrl/KT-Table.vue";
import {refData} from "@/utils/ref-data.js";
import util from "@/utils/util.js";
export default {
	name: "team-nav",
	components: {
		"kt-table": KTTable
	},
	data() {
		return {};
	},
	computed: {
		c_ktOptions() {
			return {};
		},
		c_ktColumns() {
			return [
				{
					field: "teamMemberNo",
					_numKey: true,
					openOnClick: true,
					default: true,
					sortable:true
				},
				{
					field: "teamMemberName",
					openOnClick: true,
					default: true,
					sortable:true
				},
				{
					field: "email",
					default: true,
					datatype:"email",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					sortable:true
				},
				{
					field: "phoneNo",
					title:"Phone#",
					default: true,
					datatype:"tel",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					sortable:true
				},
				{
					field: "phoneNoMobile",
					title: "Mobile#",
					default: false,
					datatype:"tel",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					sortable:true
				},
				{
					field: "phoneNoOffice",
					title: "Office#",
					default: false,
					datatype:"tel",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					sortable:true
				},
				{
					field: "faxNo",
					title:"Other#",
					default: false,
					datatype:"tel",
					fn_hrefLink: (type,value)=> {return util.fn_hrefLink(type, value);},
					valFmtFn: val => {return val?val.replace(/(\d{3})(\d{3})(\d{4})/,'$1.$2.$3'):null;},
					sortable:true
				},
				{
					field: "role",
					title: "Title/Role",
					default: true,
					sortable:true
				},
				{
					field: "appUserName",
					default: true,
					sortable:true
				},
				{field: "inactive",sortable:true},
				
				{field: "createdById", _refId: "teamMemberId",sortable:true},
				{field: "createdUTC",sortable:true},
				{field: "updatedById", _refId: "teamMemberId",sortable:true},
				{field: "updatedUTC",sortable:true},
				{field:'profilePicture', title:'Profile Photo'},
				...fn_addCustomFields()
			];
		
		}
	},
	methods: {}
};
function fn_addCustomFields(){
	var customFields=refData.customFields.filter(c=>(c.context=='team'));
	var customColumns=[];
	var customColumn;
	customFields.forEach(cf=>{
				customColumn={
						field: cf.name,
						title: cf.label,
						sortable:false,
						visible:true,
						datatype:cf.type,
						__dbvw: true,
						valFmtFn: cf.type=='money'?val => val?'$'+Number(val).toLocaleString():null:null,
						fn_hrefLink: ['email','tel','url'].includes(cf.type)?(type,value)=> 
						{if(type=='url'&&!value.includes('http')) value='http://'+value;
						return util.fn_hrefLink(type, value);}:null,
						fn_hrefAppLink: ['oppr','proj','acct','extr','cmpt','team'].includes(cf.type)?(type,value)=> {return util.fn_hrefVwRec(type, value);}:null,
						multiSelect:cf.multiSelect,
						listOfValues:cf.listOfValues,
						customField:true,
						};			
	if(customColumn.multiSelect) customColumn.valFmtFn=(val)=>{return val instanceof Array?val.join():null;};			
	customColumns.push(customColumn);

		});
	return customColumns;
}
</script>

<style lang="less">
</style>